import styled, { css } from 'styled-components'
import { Grid } from 'react-flexbox-grid'
import { H1, P } from '../Globals/index.style'
import { Row, Col } from 'react-flexbox-grid'

// import styled, { css } from 'styled-components'
// import { Grid } from 'react-flexbox-grid'
// import { H1, P } from '../Globals/index.style'

// export const FullWidthGrid = styled(Grid)`
//   width: 100%;

//   @media (min-width: 552px) {
//     margin-top: 14px 0;
//   }
// `

export const Banner = styled.section`
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  min-height: 780px;
  height: 100%;
  /* height: auto; */
  width: 100%;
  overflow: hidden;
  position: relative;

  @media (max-width: 991px) {
    min-height: 600px;
  }

  /* height: auto; */
  /* height: 100%;
  min-height: 100vh; */
  /* height: 850px; */

  /* background-color: rgb(45, 47, 61); */
  /* min-height: 400px; */

  /* @media (min-width: 320px) {
    height: auto;
  } */

  /* @media (min-width: 552px) {
    max-height: 848px;
    height: 40vw;
  } */

  /* LoadingBG */
  ${({ image }) =>
    image &&
    css`
      background-image: url(${image}?w=920&q=100&fit=scale&fm=png);
    `}
`

export const BannerBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(45, 47, 61, 0.68);
  );
`

export const BannerTextWrapper = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 6vw;
`

export const BannerCenterTextWrapper = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 16%;

  /* @media (max-width: 575px) {
    margin-top: 140px;
  } */
  /* margin-top: 355px; */
`

export const Heading = styled.h1`
  font-weight: bold;
  /* font-size: 80px;
  line-height: 80px; */
  letter-spacing: -2.01026px;
  color: #ffffff;
  margin-bottom: 44px;
  span {
    color: #83b53c;
  }
`
export const RowWrapper = styled(Row)`
  justify-content: center;
  text-align: center;
`
